<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3485 3485"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_307893816">
   <g>
    <path class="fil0" d="M1127 0c-862,0 -1127,748 -1127,1118 0,369 170,653 303,795 133,142 227,171 265,455 39,284 247,284 247,284l284 0 56 0 285 0c0,0 208,0 246,-284 38,-284 132,-313 265,-455 133,-142 303,-426 303,-795 0,-370 -265,-1118 -1127,-1118z"/>
   </g>
   <g>
    <path class="fil0" d="M1411 2889l-284 0 -9 0 -285 0c0,0 -199,0 -199,142 0,142 48,255 114,255 67,0 133,199 133,199l237 0 9 0 237 0c0,0 66,-199 132,-199 67,0 114,-113 114,-255 0,-142 -199,-142 -199,-142z"/>
   </g>
  </g>
 </g>
 <g id="Vrstva_x0020_1_0">
  <path class="fil1" d="M466 1392l0 -456 157 0c35,0 62,2 81,7 26,6 48,17 67,32 24,21 42,47 54,78 12,32 18,68 18,109 0,34 -4,65 -12,92 -9,27 -19,49 -32,66 -12,18 -26,32 -41,42 -15,10 -33,17 -55,23 -21,5 -45,7 -73,7l-164 0zm60 -53l97 0c30,0 54,-3 71,-9 17,-5 31,-13 41,-23 14,-15 25,-34 33,-58 8,-24 12,-54 12,-88 0,-48 -8,-85 -23,-110 -16,-26 -35,-43 -57,-52 -16,-6 -42,-9 -78,-9l-96 0 0 349z"/>
  <path id="1" class="fil1" d="M876 1392l174 -456 67 0 185 456 -68 0 -53 -138 -192 0 -50 138 -63 0zm131 -187l155 0 -47 -126c-15,-39 -26,-70 -33,-96 -6,30 -15,59 -25,88l-50 134z"/>
  <polygon id="2" class="fil1" points="1348,1392 1348,936 1408,936 1408,1339 1632,1339 1632,1392 "/>
  <polygon id="3" class="fil1" points="1715,1392 1715,936 1775,936 1775,1392 "/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'LightDALI',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE;fill-rule:nonzero}
.fil0 {fill:#CCCCCC;fill-rule:nonzero}
</style>
